var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input--btn" }, [
    _c(
      "div",
      { staticClass: "input-top" },
      [
        _c("div", { staticClass: "label-container" }, [
          _vm.agentLiteral
            ? _c(
                "p",
                { staticClass: "title-input text-small black mg mg--b-2" },
                [_vm._v(_vm._s(_vm.$t(_vm.agentLiteral)))]
              )
            : _c(
                "p",
                { staticClass: "title-input text-small black mg mg--b-2" },
                [_vm._v(_vm._s(_vm.$t(_vm.literal)))]
              )
        ]),
        _vm.showTooltipBtn
          ? _c("ma-tooltip", { attrs: { textInfo: _vm.textTooltipBtn } })
          : _vm._e()
      ],
      1
    ),
    _c(
      "ul",
      { staticClass: "input__wrapper" },
      [
        _vm.showCancel
          ? _c("li", [
              _c(
                "label",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleClick(null)
                    }
                  }
                },
                [
                  _c("div", { class: _vm.buttonContentClass }, [
                    _c("p", { staticClass: "text-medium blueDark" }, [
                      _vm._v("Réinitialiser")
                    ])
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._l(_vm.options, function(option) {
          return _c("li", { key: option.key }, [
            _c(
              "label",
              {
                class: {
                  "input--btn--icon": option.agent_icon,
                  checked: _vm.isChecked(option.key)
                }
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { class: _vm.buttonContentClass },
                      [
                        option.agent_icon
                          ? _c("svgicon", {
                              attrs: {
                                icon: option.agent_icon,
                                height: "42",
                                width: "auto"
                              }
                            })
                          : _vm._e(),
                        _c("p", { staticClass: "text-medium blueDark" }, [
                          _vm._v(_vm._s(_vm.$t(option.literal)))
                        ]),
                        _vm.type === "checkbox"
                          ? _c("input", {
                              attrs: {
                                type: "checkbox",
                                for: _vm.name,
                                name: _vm.name
                              },
                              domProps: {
                                value: option.key,
                                checked: _vm.isChecked(option.key)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(option)
                                }
                              }
                            })
                          : _c("input", {
                              attrs: { type: "radio", name: _vm.name },
                              domProps: {
                                value: option.key,
                                checked: _vm.isChecked(option.key)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(option)
                                }
                              }
                            })
                      ],
                      1
                    ),
                    _vm.isChecked(option.key) && _vm.showNumberSelector
                      ? _c("ma-number-selector", {
                          attrs: {
                            max: option.maxId,
                            defaultNumberSelected: _vm.pieceSelected.piece_id
                          },
                          on: {
                            change: function($event) {
                              return _vm.onPieceNumberSelected($event, option)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }